export enum UserRole {
    DNB = <any>'DNB',
    READ = <any>'READ',
    USER = <any>'USER',
    ADMIN = <any>'ADMIN',
    SYSTEM = <any>'SYSTEM',
}



// WEBPACK FOOTER //
// ./src/app/shared/models/user-role.enum.ts